// LoadingButton.jsx
import React, { useState } from "react";
import { Button, Spinner } from "react-bootstrap";

const LoadingButton = ({ onClick, children, spinner, ...props }) => {
  const [loading, setLoading] = useState(false);

  const handleClick = async (e) => {
    if (!onClick) return;

    try {
      setLoading(true);

      // If onClick returns a promise, await it
      const result = onClick(e);
      if (result instanceof Promise) {
        await result;
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      {...props}
      disabled={loading || props.disabled}
      onClick={handleClick}
    >
      {loading && (spinner ||
        <Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
          className="me-2"
        />
      )}
      {loading ? "Loading..." : children}
    </Button>
  );
};

export default LoadingButton;


// Usage:
//     <LoadingButton onClick={handler}>Click Me!!!!</LoadingButton>
//     <LoadingButton onClick={handler}>{({loading}) => (<div>{loading ? "I am processing" : "Click Me!!!!"}</div>) }</LoadingButton>